module.exports = __webpack_public_path__ + "static/media/de.74018f0a.svg";